// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tm-0";
export var checkoutRateBadgeLink = "_tm-1";